// Libs
import { createSelector } from 'reselect'

// Selectors
import getAllRequestsByStatus$ from './getAllRequestsByStatus'

// Constants
import { IN_PROGRESS } from '../constants'

export default createSelector(
  getAllRequestsByStatus$(IN_PROGRESS),
  (requests) => requests
)
